export { default as Create } from './Create';
export { default as List } from './List';
export { default as Update } from './Update';
export { default as Top } from './Top';
export { default as UsersRegistration } from './UsersRegistration';
export { default as UsersPresence } from './UsersPresence';


// WEBPACK FOOTER //
// ./src/features/admin/events/index.js